<div class="boxForm contacto" id="contentAll"> 
    <h2>{{tituloForm}}</h2>
 
</div>
